<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="模板名称:" prop="modelName">
                <el-input placeholder="" v-model="searchFrom.modelName"></el-input>
              </el-form-item>
              <el-form-item label="标签名称:" prop="labelName">
                <el-input  placeholder="" v-model="searchFrom.labelName"></el-input>
              </el-form-item>
            </div>
        </div> 
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="addClick">新增</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="changeClick(scope.row)">修改</el-button>
              <el-button type="text" size="mini" @click="delFn(scope.row)">删除</el-button>
              <el-button type="text" size="mini" @click="lookFN(scope.row)">示例图片</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="modelName"  min-width="220" :formatter="emptyFn" label="模板名称"></el-table-column> 
        <el-table-column prop="modelOcrId"  min-width="200" :formatter="emptyFn" label="百度OCR模板ID"></el-table-column>
        <el-table-column property="modelForm" label="识别方式" min-width="150" :formatter="emptyFn">
          <template slot-scope="scope">
              {{["扫码,拍照", "扫码", "拍照"][scope.row.modelForm]}}
          </template>
        </el-table-column>  
        <el-table-column property="modelRule" label="模板规则" min-width="200" :formatter="emptyFn"></el-table-column> 
        <el-table-column property="methodName" label="解析方法" min-width="200" :formatter="emptyFn"></el-table-column> 
        <el-table-column property="fileUrl" label="解析地址" min-width="200" :formatter="emptyFn"></el-table-column>
        <el-table-column label="所属标签" width="260"  >
          <template slot-scope="scope">
              <div type="text" size="mini"  >
                <template>
                  {{scope.row.labelTab}}
                  <span @click="moreFN(scope.row)" v-if="scope.row.labelFlag==1" style="color:#409eff">
                     ...更多
                  </span>
                </template>
              </div>
          </template>
        </el-table-column> 
        <el-table-column property="remark" label="备注信息" min-width="200" :formatter="emptyFn"></el-table-column> 
        <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime"  min-width="200" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog  :title="title"  :visible.sync="SQMark" width="1000px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="140px" size="mini">
        <div class="inpBox">
            <div style="margin: 28px 0;">
                <el-form-item label="模板名称:" prop="modelName">
                  <el-input  placeholder="" maxlength="50" v-model="SQFrom.modelName" ></el-input>
                </el-form-item>
                <el-form-item label="百度OCR模板ID:" prop="modelOcrId">
                 <el-input  placeholder="" maxlength="60" v-model="SQFrom.modelOcrId" ></el-input>
                </el-form-item>
                <el-form-item label="识别方式:" prop="modelForm">
                    <el-select v-model="SQFrom.modelForm" placeholder="请选择">
                      <el-option v-for="val in yzcj" :label="val.name" :value="val.id" :key="val.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="解析方法:" prop="methodName" class="jiage" >
                  <el-select v-model="SQFrom.methodName" filterable placeholder="请选择" value-key="id" @change="Changge">
                     <el-option
                      v-for="item in methodList"
                      :key="item.id"
                      :label="item.businessName"
                      :value="item">
                     </el-option>
                    </el-select>
                </el-form-item>
                 <el-form-item label="模板规则:" class="jiage" prop="modelRule" >
                  <el-input  placeholder=""  v-model="SQFrom.modelRule" ></el-input>
                </el-form-item>
                <el-form-item label="解析地址:" class="jiage" prop="fileUrl" >
                  <el-input  placeholder="" v-model="SQFrom.fileUrl"  ></el-input>
                </el-form-item>
                <el-form-item label="模板简称:" class="jiage" prop="modelNickName" >
                  <el-input  placeholder=""  v-model="SQFrom.modelNickName" ></el-input>
                </el-form-item>
                <div>
                  <el-form-item label="备注信息:" prop="remark" >
                  <el-input type="textarea" v-model="SQFrom.remark" style="width:450px" rows="8"></el-input>
                </el-form-item>
                <el-form-item label="示例照片:" prop="file" >
                <div class="imgbox">
                  <el-upload
                      action=""
                      :file-list="listImg1"
                      ref="upload"
                      :auto-upload="false"
                      :on-change="imgPreview1"
                      list-type="picture-card"
                      accept="image/*"
                      :limit="1"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                    </el-upload>
                </div>
              </el-form-item>
                </div>
                <!-- <el-form-item label="备注信息:" prop="remark" >
                  <el-input type="textarea" v-model="SQFrom.remark" style="width:450px" rows="8"></el-input>
                </el-form-item>
                <el-form-item label="示例照片:" prop="file" >
                <div class="imgbox">
                  <el-upload
                      action=""
                      :file-list="listImg1"
                      ref="upload"
                      :auto-upload="false"
                      :on-change="imgPreview1"
                      list-type="picture-card"
                      accept="image/*"
                      :limit="1"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove1" :class="[isAddImg1?'hidden':'']">
                    </el-upload>
                </div>
              </el-form-item> -->
             </div>  
             <div style="margin:28px 50px;" >  
              <h4>
                <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>关联标签</span>
              </h4>
              <div>
                <el-checkbox-group v-model="SQFrom.labelIds" >
                  <el-checkbox-button v-for="item in labelList" :label="item.id"  :key="item.id" @change="Changge1" >{{item.labelName}}</el-checkbox-button>
                </el-checkbox-group>
              </div>
             </div> 
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false" size='mini'>取消</el-button>
        <el-button type="primary" size='mini'  @click="saveFn('SQFrom')" v-show="addBtnShow" >保 存</el-button>
        <el-button type="primary" size='mini'  @click="changeBaoCun('SQFrom')" v-show="changeBtnShow">修 改</el-button>
      </span>
   </el-dialog>
   <el-dialog  title="查看示例图片"  :visible.sync="seeQuXiaoClick" width="700px"   :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
    <div class="imgBox" style="margin-left: 25px"  >
        <el-image
            :src="exampleImageUrlOSS" 
            style="width: 600px; height: 300px"
            :preview-src-list="[exampleImageUrlOSS]"
            >
        </el-image>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="seeQuXiaoClick = false" type="primary">关闭</el-button>
      </span>
    </el-dialog>
     <el-dialog title="查看图片" :visible.sync="lookImgVisible" center="">
      <img width="100%"  :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog title="所属标签" :visible.sync="labelVisible" center="">
      <label>所属标签:</label>
      <p>{{SQFrom.labelName}}</p>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { 
         cOcrModelAdd, // 添加确定
         cOcrModelList, // 列表
        //  checkExampleImage, // 示例图片
         cOcrModelDelete, // 删除
         cOcrModelUpdate, // 修改保存
         labelList, // 获取关联标签列表
         methodList, // 获取解析方法列表
         cOcrModelDetail// 修改调取
         } from '@/api/common-signature'
export default {
  data () {
    return {
      DETAILList: [],
      dialogImageUrl: '',
      labelList: [],
      file: '',
      methodList: [],
      labelVisible: false,
      imgfile: new FormData(),
      addBtnShow: true, // 新增页面保存按钮
      changeBtnShow: false, // 修改页面保存按钮
      title: '',
      lookImgVisible: false,
      isAddImg1: false,
      listImg1: [],
    uploadImageUrl: '',
    shouquanClick: false,
    exampleImageUrlOSS:'',
    seeQuXiaoClick: false,
      yzcj: [
        { name: '扫码,拍照', id: 0 },
        { name: '扫码', id: 1 },
        { name: '拍照', id: 2 },
      ],
      options: [],
      zjList: [],
      SQFrom: {
        labelIds: []
      },
      SQMark: false,
      rules: {
        modelName: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        modelOcrId: [
          { required: true, message: '请输入百度OCR模板ID', trigger: 'blur' }
        ],
        methodName: [
          { required: true, message: '请选择解析方法', trigger: 'blur' }
        ],
        modelForm: [
          { required: true, message: '请选择识别方式', trigger: 'blur' }
        ],
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      goodTypes: [],
      btnFlg: [],
      btnIdArr: ['004P003B000', '004P003B001', '004P003B002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemSetup/address')
    this.getList(this.searchFrom)
    this.imgfile.append('params', '')
    this.imgfile.append('file', '')
    
    labelList().then(res => {
      this.labelList = res
    }) 
    // 解析方法列表
    methodList().then(res => {
      this.methodList = res
    }) 
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    Changge(val){
        // // console.log(this.SQFrom);
        // console.log(this.SQFrom.methodName);
        this.SQFrom.methodName = val
        this.SQFrom.methodId = this.SQFrom.methodName.id
        this.SQFrom.methodName = this.SQFrom.methodName.businessName
    },
     Changge1(val){
        // console.log(val + '22222');
        // console.log(this.SQFrom);
        // console.log(this.SQFrom.labelIds)
        this.$set(this.SQFrom, 'updateLabelIds', this.SQFrom.labelIds)
    },
    moreFN(row) {
      this.labelVisible = true
      this.$set(this.SQFrom, 'labelName', row.labelName)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.lookImgVisible = true
    },
    // 图片上传
    handleRemove1 (file, fileList) {
      console.log(file, fileList)
      if (fileList.length < 1) {
        this.isAddImg1 = false
      }
      this.listImg1 = fileList
      console.log(this.listImg1.length)
    },
    imgPreview1 (file, fileList) {
      // console.log(file, fileList)
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/
      if (regex.test(fileName.toLowerCase())) {
        if (fileList.length < 1) {
          this.isAddImg1 = false
        } else {
          this.isAddImg1 = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
      this.listImg1 = fileList
    },
    // 添加模板
    addClick () {
      this.title = '添加模板'
      this.SQMark = true
      this.addBtnShow = true
      this.changeBtnShow = false
      this.$nextTick(() => {
        this.$refs["SQFrom"].clearValidate(); 
      })  
    },
    // 添加保存
     saveFn () {
        if (this.SQFrom.labelIds.length == 0) {
           return this.$message.error('必须选择至少一个标签')  
        }
        if (this.listImg1.length == 0) {
           return this.$message.error('请上传示例照片')  
        }
          this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.imgfile.set('params', JSON.stringify(this.SQFrom))
          if (this.listImg1.length > 0) {
            this.imgfile.set('file', this.listImg1[0].raw) 
          }

        cOcrModelAdd(this.imgfile).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })

    },
    // 修改
    changeClick(row) {
      this.title = '修改模板'
      this.SQMark = true
      this.changeBtnShow = true
      this.addBtnShow = false
      cOcrModelDetail({id: row.id}).then(res => {
        this.SQFrom = res 
        this.$set(this.SQFrom, 'labelIds', [])   
        // this.SQFrom.labelIds = []
        // console.log(this.SQFrom.labelId.split(','))
        // this.SQFrom.labelIds = this.SQFrom.labelId.split(',')
        this.SQFrom.labelId.split(',').forEach(element => {
          this.SQFrom.labelIds.push(Number(element))
       }) 
      }) 
      if (row.exampleImageUrlOSS) {
        this.$set(this.listImg1, 0, { status: 'ready', url: row.exampleImageUrlOSS })
        this.isAddImg1 = true
      } else {
        this.listImg1 = []
        this.isAddImg1 = false
      }

    },
    changeBaoCun(formName){
       if (this.SQFrom.labelIds.length == 0) {
           return this.$message.error('必须选择至少一个标签')  
        }
        if (this.listImg1.length == 0) {
           return this.$message.error('请上传示例照片')  
        }
          this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          this.imgfile.set('params', JSON.stringify(this.SQFrom))
          if (this.listImg1.length > 0) {
            this.imgfile.set('file', this.listImg1[0].raw) 
          }
        cOcrModelUpdate(this.imgfile).then(res => {
            loading.close()
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })   
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cOcrModelDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查看
    lookFN (row) {
      this.seeQuXiaoClick = true
      // console.log(row);
      this.exampleImageUrlOSS = row.exampleImageUrlOSS
      cOcrModelDetail({ id: row.id }).then(res => {
      })
      // console.log(this.exampleImageUrlOSS); 
      // checkExampleImage({ id: row.id }).then(res => {
      // })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      cOcrModelList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      this.imgfile.set('params', '')
      this.listImg1 = []
      this.isAddImg1 = false
      this.SQFrom = {
         labelIds: []
      }
    },
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}

/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;  
  }
}
    .imgBox{
      margin: 22px 10px;
    }
    .hidden /deep/.el-upload--picture-card{
      display: none;
    }
</style>
